import React from "react";
import { Navigate } from "react-router-dom";


const ProductionManagerProtectedRoute = ({ component: Component, ...rest }) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const is_Auth = userDetails?.accessToken;
    const is_ProductionManager = userDetails?.role === "production_manager";

  return is_Auth && is_ProductionManager ? <Component {...rest} /> : <Navigate to="/" />;
};

export default ProductionManagerProtectedRoute;
